import * as React from 'react';
import { Button } from '@morressier/ts';
import {
  ToolTipWrapper,
  ToolTipContainer,
  ToolTipTitle,
  ToolTipText,
  TextWrapper,
  ButtonWrapper,
} from './style';

export type ActionButton = {
  method: () => void;
  key: string;
  text: string;
  styles: React.CSSProperties;
  color: 'red' | 'secondary' | 'twitter' | 'facebook' | 'linkedin' | 'orcid' | 'primary' | 'danger';
};

const renderActionButtons = (props: ActionButton[]) =>
  props.map((actionBtn: ActionButton) => (
    <Button
      key={actionBtn.key}
      type="button"
      color={actionBtn.color}
      style={{ ...actionBtn.styles }}
      onClick={actionBtn.method}
    >
      {actionBtn.text}
    </Button>
  ));
export const AdvanceToolTip = ({
  title,
  width,
  description,
  element,
  visible,
  actionButtons,
}: {
  title: string;
  description: string;
  width: string;
  element: React.ReactElement;
  visible: boolean;
  actionButtons: ActionButton[];
}) => (
  <ToolTipWrapper>
    {element}
    <ToolTipContainer width={width} visible={visible}>
      <TextWrapper>
        <ToolTipTitle>{title}</ToolTipTitle>
      </TextWrapper>
      <TextWrapper>
        <ToolTipText>{description}</ToolTipText>
      </TextWrapper>
      <ButtonWrapper>{actionButtons && renderActionButtons(actionButtons)}</ButtonWrapper>
    </ToolTipContainer>
  </ToolTipWrapper>
);
